<template>
	<div class="p-p-2 content">
		<TranslationListView
			v-if="documentClassTranslationFilter"
			:key="documentClassTranslationFilter"
			:fixedFilter="documentClassTranslationFilter"
		/>
	</div>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, reactive, watch} from "vue";
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";
import {DocumentClass} from "@dex/squeeze-client-ts";
import {ClientManager} from "@/singletons/ClientManager";
import {ToastManager} from "@/util/ToastManager";
import TranslationListView from "@/apps/administration/views/squeeze/system/TranslationListView.vue";

export default defineComponent({
	name: "DocumentClassTranslationsSubView",
	components: {
		TranslationListView,
	},
	props: {
		documentClassId: {
			type: Number,
			default: 0,
		},
	},
	setup(props) {
		const {t} = useI18n();
		const toast = useToast();

		/** Service for loading the current document class name used in translation keys */
		const documentClassService = ClientManager.getInstance().squeeze.documentClass;

		/** Current document class; only the name is needed for the fixed translation filter */
		const documentClass = reactive<DocumentClass>({
			name: '',
			description: '',
		});

		/** Fixed translations filter for all keys that belong to the current document class */
		const documentClassTranslationFilter = computed<string>(() => {
			return documentClass.name ? `documentclasses.${documentClass.name}.*` : '';
		});

		/** Gets the document class to derive the fixed translations filter */
		const getDocumentClass = () => {
			if (!props.documentClassId) {
				return;
			}

			documentClassService.getDocumentClassById(props.documentClassId)
				.then((data: DocumentClass) => {
					Object.assign(documentClass, data);
				})
				.catch((err: { statusText: string }) => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.DocumentClasses.DocumentClass') + ": " + err.statusText);
				});
		};

		onMounted(() => {
			getDocumentClass();
		});

		watch(() => props.documentClassId, () => {
			getDocumentClass();
		});

		return {
			documentClassTranslationFilter,
		};
	},
});
</script>

<style scoped>
.content {
	height: calc(100vh - 5.6rem - 4.1rem);
}
</style>
